<template>
  <div class="risk-progress">
    <div class="risk-progress__track">
      <div
          class="risk-progress__active"
          :style="{ width: normalizedPercent + '%' }"
      >
        <div
            v-if="normalizedPercent > 0"
            class="risk-progress__gradient"
            :style="{ width: gradientWidth }"
        ></div>
      </div>
    </div>

    <div class="risk-progress__labels">
      <span>низкий</span>
      <span>высокий</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RiskProgress',
  props: {
    percent: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    normalizedPercent() {
      if (!Number.isFinite(this.percent)) return 0;

      return Math.min(100, Math.max(0, this.percent));
    },

    gradientWidth() {
      if (this.normalizedPercent <= 0) return '0%';
      return `${10000 / this.normalizedPercent}%`;
    },
  },
};
</script>

<style scoped>
.risk-progress {
  width: 100%;
}

.risk-progress__track {
  margin-bottom: 4px;
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: #eef2f8;
  overflow: hidden;
}

.risk-progress__active {
  height: 100%;
  overflow: hidden;
  border-radius: 999px 0 0 999px;
}

.risk-progress__gradient {
  height: 100%;
  background: linear-gradient(
      90deg,
      #f45b5b 0%,
      #ff9348 25%,
      #e9d934 50%,
      #9dde3f 72%,
      #63c95b 100%
  );
}

.risk-progress__labels {
  display: flex;
  justify-content: space-between;
  text-transform: lowercase;
  margin: 0 auto;
  font-size: 12px;
  line-height: 110%;
  color: rgba(0, 0, 0, 0.45);
}
</style>